import React from "react";

/**
 * SourceList - Displays tool sources in human-readable format
 * @param {Object} props
 * @param {string[]} props.sources - Array of source identifiers
 * @returns {JSX.Element}
 */
const SourceList = ({ sources }) => {
    if (!sources || sources.length === 0) return null;

    // Display name mapping for tool sources
    const toolDisplayNames = {
        "get_shipment_status": "Shipment Lookup",
        "get_shipment": "Shipment Lookup",
        "shipment": "Shipment Data",
        "get_invoice_details": "Invoice Lookup",
        "get_invoice": "Invoice Lookup",
        "invoice": "Invoice Data",
        "get_order_status": "Order Lookup",
        "get_order": "Order Lookup",
        "order": "Order Data",
        "search_shipments": "Shipment Search",
        "search_invoices": "Invoice Search",
        "search_orders": "Order Search",
        "get_customer": "Customer Data",
        "get_carrier": "Carrier Data",
        "database": "Database",
        "api": "API",
    };

    /**
     * Get display name for a source
     */
    const getDisplayName = (source) => {
        if (!source) return "Unknown";
        return toolDisplayNames[source] || toolDisplayNames[source.toLowerCase()] || formatSourceName(source);
    };

    /**
     * Format source name to readable text
     */
    const formatSourceName = (source) => {
        return source
            .replace(/[_-]/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase())
            .trim();
    };

    return (
        <div className="flex flex-wrap items-center gap-2 mt-2">
            <span className="text-xs text-gray-500">Data from:</span>
            <div className="flex flex-wrap gap-1.5">
                {sources.map((source, idx) => (
                    <span
                        key={idx}
                        className="text-xs px-2 py-0.5 bg-blue-50 text-blue-600 rounded-full font-medium"
                    >
                        {getDisplayName(source)}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default SourceList;
